declare namespace $ {

	type $mol_list__rows_shm_hitalama_components_history_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_history['rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_hitalama_components_history_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_hitalama_components_history_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_history['archive_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_hitalama_components_history_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_shm_hitalama_components_history_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_history['entry_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_hitalama_components_history_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	export class $shm_hitalama_components_history extends $mol_page {
		rows( ): readonly(any)[]
		Entries( ): $mol_list
		Archive_title( ): $mol_view
		archive_rows( ): readonly(any)[]
		Archive( ): $mol_list
		archive_visible( ): readonly($mol_view)[]
		entry_arg( id: any): Record<string, any>
		entry_title( id: any): string
		versions( ): $shm_hitalama_components_versions
		selected( next?: string ): string
		title( ): string
		minimal_width( ): number
		body( ): readonly(any)[]
		Empty( ): $mol_view
		Entry( id: any): $mol_link
	}
	
}

//# sourceMappingURL=history.view.tree.d.ts.map